import {Component, Inject, Input, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NcDocumentFormComponent} from '../nc-document-form/nc-document-form.component';
import {Observable, throwError} from 'rxjs';
import {BaseComponent, Option} from 'nc-shared';
import {FormArray, FormGroup} from '@angular/forms';
import {FormUtils} from 'nc-utils';

@Component({
  selector: 'nc-document-form-dialog',
  templateUrl: './nc-document-form-dialog.component.html',
  styleUrls: ['./nc-document-form-dialog.component.scss']
})
export class NcDocumentFormDialogComponent extends BaseComponent {
  @ViewChild(NcDocumentFormComponent) form;

  @Input() cancelButtonId: string;
  @Input() saveButtonId: string;
  @Input() fileUploadId: string;
  @Input() inputId: string;
  @Input() selectId: string;
  @Input() selectSearchTextId: string;
  @Input() selectSearchButtonId: string;
  @Input() selectClearIconId: string;

  constructor(public dialogRef: MatDialogRef<NcDocumentFormDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {
                formGroup: FormGroup, documentTypes$: Observable<Array<Option>>, formArray: FormArray
              }) {
    super();
  }

  getDocumentTitle(): string {
    return this.data.formGroup.get('name').value ? 'editDocumentTitle' : 'newDocumentTitle';
  }

  submit = () => {
    if (this.data.formGroup.invalid) {
      FormUtils.validateAllFormFields(this.data.formGroup);
      return throwError(new Error('FORM_NOT_VALID'));
    }

    this.data.formArray.markAsDirty();

    return this.dialogRef.close({success: true});
  }
}
